import React from 'react';

import Page from '../components/Page';
import { ImageModifier } from '../hooks/hooks';

import { ReactComponent as Logo } from './p1/logo.svg';

import './p1.css';
import '../components/Typography.css';

function P1({
  gata,
  storlekGata,
  område,
  splash,
  splashModifier,
}: {
  gata: string;
  storlekGata: string;
  område: string;
  splash: string;
  splashModifier: ImageModifier;
}) {
  return (
    <Page className="P1">
      <div className="P1--splash-container">
        <img
          {...splashModifier}
          className="P1--splash-picture"
          alt="splash"
          src={splash}
        />
      </div>
      <div className={`P1--gata ${storlekGata}`}>{gata}</div>
      <div className="P1--omrade">{område}</div>
      <div className="P1--logo-container">
        <Logo width="120pt" height="27pt" />
      </div>
    </Page>
  );
}

export default P1;
